import { FocusZoneMode } from '../../types';
import * as keyboardKey from 'keyboard-key';
import { FocusZoneDirection, IS_FOCUSABLE_ATTRIBUTE } from '../../FocusZone';
var CHAT_FOCUSZONE_ATTRIBUTE = 'chat-focuszone';
/**
 * @description
 * Adds role 'presentation' until we come up with final roles for chat.
 * Adds a vertical focus zone navigation with a last message as a default tabbable element, pressing enter key focuses inside a message.
 * Adds a escape key action which focuses the chat, i.e., moves key handling from inside a message back to the chat list.
 */
var ChatBehavior = function (props) {
    var _a;
    return ({
        attributes: {
            root: {
                role: 'presentation',
            },
        },
        focusZone: {
            mode: FocusZoneMode.Wrap,
            props: (_a = {
                    shouldEnterInnerZone: function (event) { return keyboardKey.getCode(event) === keyboardKey.Enter; },
                    direction: FocusZoneDirection.vertical,
                    shouldResetActiveElementWhenTabFromZone: true,
                    defaultTabbableElement: getLastTabbableElement
                },
                _a[CHAT_FOCUSZONE_ATTRIBUTE] = '',
                _a),
        },
        keyActions: {
            root: {
                focus: {
                    keyCombinations: [{ keyCode: keyboardKey.Escape }],
                },
            },
        },
    });
};
var getLastTabbableElement = function (root) {
    var lastVisibleMessage = root.querySelector('[data-last-visible="true"]');
    if (lastVisibleMessage)
        return lastVisibleMessage;
    var chatItemsElements = root.querySelectorAll("[" + CHAT_FOCUSZONE_ATTRIBUTE + "] .ui-chat__message[" + IS_FOCUSABLE_ATTRIBUTE + "=\"true\"]");
    return chatItemsElements.length > 0
        ? chatItemsElements[chatItemsElements.length - 1]
        : null;
};
export default ChatBehavior;
